import { INBOX, KB } from 'ducks/billing/productTypes'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectPendingFuturePhaseDetailed } from 'ducks/billing/selectors/selectPendingFuturePhaseDetailed'
import { selectCurrentBillingCycle } from 'ducks/billing/selectors/selectCurrentBillingCycle'
import { selectAvailablePlansByProduct } from 'ducks/billing/selectors/selectAvailablePlansByProduct'
import { isPlanLimitsExceeded } from 'ducks/billing/util'
import { selectUsageForProduct } from 'ducks/billing/selectors/usage'
import KbFeatures from './KbFeatures'
import InboxFeatures from './InboxFeatures'

const Features = ({ planId, productType }) => {
  const billingPlans = useSelector(state =>
    selectAvailablePlansByProduct(state, productType)
  )
  const currentCycle = useSelector(selectCurrentBillingCycle)
  const newPlan = billingPlans.find(plan => plan.planId === planId)
  const usage = useSelector(state => selectUsageForProduct(state, productType))
  const pendingFuturePhaseByProduct = useSelector(
    selectPendingFuturePhaseDetailed
  )
  const pendingFuturePhase = pendingFuturePhaseByProduct[productType]
  const { cycle } = pendingFuturePhase || {}
  const isDowngradeCycle = cycle && currentCycle !== cycle

  const planLimitsExceeded =
    isDowngradeCycle || !newPlan ? false : isPlanLimitsExceeded(newPlan, usage)

  if (!planLimitsExceeded) return null

  return (
    <>
      {productType === KB && (
        <KbFeatures {...newPlan.features} className="grui mt-10" />
      )}
      {productType === INBOX && (
        <InboxFeatures
          {...newPlan.features}
          className="grui mt-10"
          newPlanId={planId}
        />
      )}
    </>
  )
}

export default Features
